import { Get } from './index'

// 获取 up 主信息
export const getAdminInfo = Get('/common/admin_info')
// 验证动态码
export const verifyAuthCode = Get('/common/auth_code')
